import { render } from "./DetailBarang.vue?vue&type=template&id=4b1cab2e&scoped=true"
import script from "./DetailBarang.vue?vue&type=script&lang=js"
export * from "./DetailBarang.vue?vue&type=script&lang=js"

import "./DetailBarang.vue?vue&type=style&index=0&id=4b1cab2e&scoped=true&lang=css"
import "./DetailBarang.vue?vue&type=style&index=1&id=4b1cab2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1cab2e"]])

export default __exports__